module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Want to assist in development?","desc":"This project is completely free and open source, you can find it on GitHub, or you can build an instance of DressPay yourself.","btn":{"github":"GitHub","docs":"Documentation"}},"zh":{"title":"希望协助开发运行?","desc":"本项目是完全自由且开源的，您可以在 GitHub 上找到它的所有相关代码，也可以自己搭建 DressPay 的实例。","btn":{"github":"GitHub","docs":"文档"}}}')
  delete Component.options._Ctor
}
